import {
  LOAD_OPEN_INCIDENT,
  LOAD_OPEN_INCIDENT_SUCCESS,
  LOAD_OPEN_INCIDENT_FAILED
} from "./incidentActionTypes";

export default (state = true, action) => {
  switch (action.type) {
    case LOAD_OPEN_INCIDENT:
      return true;
    case LOAD_OPEN_INCIDENT_FAILED:
    case LOAD_OPEN_INCIDENT_SUCCESS:
      return false;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/incidents/incidentsIsLoadingReducer.js